import { QuoteReservation } from '@/models/quote'
import { TimeSchedule } from '@/models/service'
import { AddedServices } from '@/store/timeScheduleSlice'
import { getTimeScheduleKey } from '../timeSchedules'

interface Param {
  addedServices: AddedServices
  otherReservations: QuoteReservation[]
  serviceId: number
  timeSchedule: TimeSchedule
}

export function getBoughtTimeSchedule(param: Param): number {
  const tsKey = getTimeScheduleKey(param.timeSchedule)

  return param.otherReservations.reduce<number>((acc, reservation) => {
    const boughtServices = reservation.boughtServices[param.serviceId]
    if (boughtServices) {
      const boughtTs = boughtServices[tsKey]
      return (boughtTs?.bought ?? 0) + acc
    }

    return acc
  }, 0)
}
